import {AfterContentInit, ContentChild, Directive, ElementRef, Input, OnDestroy, Renderer2} from '@angular/core';
import {FormControl, FormControlDirective, FormControlName, NgModel} from '@angular/forms';
import {Subject} from 'rxjs/Subject';
export class NgFormControlErrorsContent implements AfterContentInit, OnDestroy {

     checkOnDirty = true;

     _formCtrlName: FormControlName;

     _formCtrlDir: FormControlDirective;

     _ngModel: NgModel;

     _elFormCtrlName: ElementRef;

     _elFormCtrlDir: ElementRef;

     _elNgModel: ElementRef;

    onChange$ = new Subject();

    elFormCtrlBlurListener: Function;

    elFormCtrlFocusListener: Function;

    elFormCtrlInputListener: Function;
/**
 * @param {?} renderer
 */
constructor(private renderer: Renderer2) {
    }
/**
 * @return {?}
 */
ngAfterContentInit() {
        if (!this.elFormControl) {
            throw new Error(
                '.control-errors-content must be used with a child [formControl], [ngModel] or [formControlName] directive');
        }

        this.initOnChange();
    }
/**
 * @return {?}
 */
get invalid(): boolean {
        if (this.formControl) {
            return this.formControl.errors && (!this.checkOnDirty || (this.formControl.dirty || this.formControl.touched));
        } else {
            return false;
        }
    }
/**
 * @return {?}
 */
initOnChange() {
        this.elFormCtrlBlurListener = this.renderer.listen(
            this.elFormControl, 'blur', (e) => this.onChange$.next(e));
        this.elFormCtrlFocusListener = this.renderer.listen(
            this.elFormControl, 'focus', (e) => this.onChange$.next(e));
        this.elFormCtrlInputListener = this.renderer.listen(
            this.elFormControl, 'input', (e) => this.onChange$.next(e));
    }
/**
 * @return {?}
 */
get formControl(): FormControl | null {
        let /** @type {?} */ _formControl = null;

        if (this._formCtrlName) {
            _formControl = this._formCtrlName;
        } else if (this._formCtrlDir) {
            _formControl = this._formCtrlDir;
        } else if (this._ngModel) {
            _formControl = this._ngModel;
        }

        if (_formControl) {
            _formControl = ('control' in _formControl) ? _formControl.control : null;
        }

        return _formControl;
    }
/**
 * @return {?}
 */
get elFormControl(): HTMLElement | null {
        let /** @type {?} */ _elFormControl = null;

        if (this._elFormCtrlName) {
            _elFormControl = this._elFormCtrlName.nativeElement;
        } else if (this._elFormCtrlDir) {
            _elFormControl = this._elFormCtrlDir.nativeElement;
        } else if (this._elNgModel) {
            _elFormControl = this._elNgModel.nativeElement;
        }

        return _elFormControl;
    }
/**
 * @return {?}
 */
unbindElFormCtrlBlurListener() {
        if (this.elFormCtrlBlurListener) {
            this.elFormCtrlBlurListener();
            this.elFormCtrlBlurListener = null;
        }
    }
/**
 * @return {?}
 */
unbindElFormCtrlFocusListener() {
        if (this.elFormCtrlFocusListener) {
            this.elFormCtrlFocusListener();
            this.elFormCtrlFocusListener = null;
        }
    }
/**
 * @return {?}
 */
unbindElFormCtrlInputListener() {
        if (this.elFormCtrlInputListener) {
            this.elFormCtrlInputListener();
            this.elFormCtrlInputListener = null;
        }
    }
/**
 * @return {?}
 */
ngOnDestroy() {
        this.unbindElFormCtrlBlurListener();
        this.unbindElFormCtrlFocusListener();
        this.unbindElFormCtrlInputListener();
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: '.control-errors-content',
    exportAs: 'controlErrorsContent',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer2, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'checkOnDirty': [{ type: Input },],
'_formCtrlName': [{ type: ContentChild, args: [FormControlName, ] },],
'_formCtrlDir': [{ type: ContentChild, args: [FormControlDirective, ] },],
'_ngModel': [{ type: ContentChild, args: [NgModel, ] },],
'_elFormCtrlName': [{ type: ContentChild, args: [FormControlName, {read: ElementRef}, ] },],
'_elFormCtrlDir': [{ type: ContentChild, args: [FormControlDirective, {read: ElementRef}, ] },],
'_elNgModel': [{ type: ContentChild, args: [NgModel, {read: ElementRef}, ] },],
};
}

function NgFormControlErrorsContent_tsickle_Closure_declarations() {
/** @type {?} */
NgFormControlErrorsContent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgFormControlErrorsContent.ctorParameters;
/** @type {?} */
NgFormControlErrorsContent.propDecorators;
/** @type {?} */
NgFormControlErrorsContent.prototype.checkOnDirty;
/** @type {?} */
NgFormControlErrorsContent.prototype._formCtrlName;
/** @type {?} */
NgFormControlErrorsContent.prototype._formCtrlDir;
/** @type {?} */
NgFormControlErrorsContent.prototype._ngModel;
/** @type {?} */
NgFormControlErrorsContent.prototype._elFormCtrlName;
/** @type {?} */
NgFormControlErrorsContent.prototype._elFormCtrlDir;
/** @type {?} */
NgFormControlErrorsContent.prototype._elNgModel;
/** @type {?} */
NgFormControlErrorsContent.prototype.onChange$;
/** @type {?} */
NgFormControlErrorsContent.prototype.elFormCtrlBlurListener;
/** @type {?} */
NgFormControlErrorsContent.prototype.elFormCtrlFocusListener;
/** @type {?} */
NgFormControlErrorsContent.prototype.elFormCtrlInputListener;
/** @type {?} */
NgFormControlErrorsContent.prototype.renderer;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
